export default __webpack_public_path__ + "static/media/photo--sm--pubquiz.31d84bc7.jpg";